import React from 'react';
import { ACCOUNTS, SUPER_ADMIN } from '../../../../../utils/departments/helpers';
import { useUser } from '../../../../../hooks/shared/user/useUser';
import useCheckTwoDepartments from '../../../../../hooks/shared/custom/check-department/useCheckTwoDepartments';
import AccountsNavBar from '../../../../layouts/accounts/AccountsNavBar';
import AccountVehiclesBody from './AccountVehiclesBody';

const AccountsVehicles = ({ history }) => {
  useCheckTwoDepartments(`${ACCOUNTS}`, `${SUPER_ADMIN}`, history);
  const {
    profile: { firstName },
  } = useUser();

  return (
    <div className="s-layout">
      <main className="s-layout__content col-lg-10 p-0">
        <AccountsNavBar currentPage="Vehicles" position={firstName} />
        <AccountVehiclesBody />
      </main>
    </div>
  );
};

export default AccountsVehicles;
